module.exports = __webpack_public_path__ + "img/robust-trading.6cdc27ad.svg";